import { h } from "preact";
export const SearchIcon = () => {
  return (
    <svg class="modal__toggle-open icon icon-search"  aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g href="#icon-search" id="Navigation" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Header-(find-a-store)" transform="translate(-1019.000000, -77.000000)" stroke="#444444" stroke-width="1.2">
              <g id="icon-search" transform="translate(1020.000000, 78.000000)">
                  <ellipse id="Oval" cx="6.7699115" cy="6.84610249" rx="6.7699115" ry="6.84610249"></ellipse>
                  <line x1="11.6030776" y1="11.6262622" x2="15.4765684" y2="15.7581477" id="Path" stroke-linecap="round" transform="translate(13.539823, 13.692205) rotate(-1.528125) translate(-13.539823, -13.692205) "></line>
              </g>
          </g>
      </g>
    </svg>
  );
};
